import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { Link,useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const Api = process.env.REACT_APP_API;

  const handleRequestOTP = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${Api}/api/auth/request-reset-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        throw new Error("Failed to send OTP. Please check your email.");
      }

      setOtpSent(true);
      setLoading(false);
    } catch (error) {
      setError(error.message);
      setLoading(false);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`${Api}/api/auth/reset-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, otp, newPassword }),
      });

      if (!response.ok) {
        throw new Error("Failed to reset password. Please check the OTP.");
      }

      setLoading(false);
      navigate("/login");
    } catch (error) {
      setError(error.message);
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="d-flex align-items-center auth px-0">
        <div className="row w-100 mx-0">
          <div className="col-lg-4 mx-auto">
            <div className="auth-form-light text-left py-5 px-5 px-sm-5">
              <div className="brand-logo">
                <img
                  src={require("../../assets/images/Logo.png")}
                  alt="logo"
                />
              </div>
              <h4>Forgot Password</h4>
              <h6 className="font-weight-light">
                {otpSent
                  ? "Verify OTP and reset your password."
                  : "Enter your email to receive OTP."}
              </h6>
              <Form
                className="pt-3"
                onSubmit={otpSent ? handleResetPassword : handleRequestOTP}
              >
                {error && <p className="text-danger">{error}</p>}

                {!otpSent && (
                  <Form.Group className="d-flex search-field position-relative">
                    <Form.Control
                      type="email"
                      placeholder="Email"
                      size="lg"
                      className="h-auto"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </Form.Group>
                )}

                {otpSent && (
                  <>
                    <Form.Group className="d-flex search-field position-relative">
                      <Form.Control
                        type="text"
                        placeholder="Enter OTP"
                        size="lg"
                        className="h-auto"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        required
                      />
                    </Form.Group>
                    <Form.Group className="d-flex search-field position-relative">
                      <Form.Control
                        type="password"
                        placeholder="New Password"
                        size="lg"
                        className="h-auto"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                      />
                    </Form.Group>
                    <Form.Group className="d-flex search-field position-relative">
                      <Form.Control
                        type="password"
                        placeholder="Confirm Password"
                        size="lg"
                        className="h-auto"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                      />
                    </Form.Group>
                  </>
                )}

                <div className="mt-3">
                  <button
                    type="submit"
                    className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                    disabled={loading}
                  >
                    {loading
                      ? "Processing..."
                      : otpSent
                      ? "Reset Password"
                      : "Request OTP"}
                  </button>
                </div>
                <div className="text-center mt-4">
                  <Link to="/login" className="auth-link text-black">
                    Back to Login
                  </Link>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
